import owd from 'owd/owd';

export default class Filter extends owd.Component {
	init() {
		this.bind();
	}

	bind() {
        this.on('click', (e) => {
            this.$element.parents('[data-products]').find('a.active').removeClass('active');
            this.$element.addClass('active');
        });
    }

    destroy() {
        super.destroy();
    }
}

owd.registerComponent('filter', {
	component: Filter
});
